import { PaletteOptions } from '@mui/material/styles/createPalette';

const secondaryMain= "#252A2E";

export const palette = {
  primary: {
    main: '#0063A3',
    light: '#217CBB',
    dark: '#004F83',
  },
  secondary: {
    main: secondaryMain,
  },
  success: {
    main: '#349C44',
    light: '#82BF4A',
    dark: '#006638',
  },
  text: {
    primary: secondaryMain,
    secondary: secondaryMain,
  },
  error: {
    main: '#DA212C',
    light: '#E86363',
    dark: '#AB1F26',
  },
  neutralGray: {
    main: '#585C65',
    light: '#F1F1F6',
    dark: '#585C65',
    contrastText: '#FFFFFF',
  },
  neutralGray0: {
    main: '#E0E1E9',
    light: '#E0E1E9',
    dark: '#E0E1E9',
  },
  neutralGray1: {
    main: '#CBCDD6',
    light: '#CBCDD6',
    dark: '#CBCDD6',
  },
  neutralGray2: {
    main: '#B7B9C3',
    light: '#B7B9C3',
    dark: '#B7B9C3',
  },
  neutralGray3: {
    main: '#A3A6B1',
    light: '#A3A6B1',
    dark: '#A3A6B1',
  },
  neutralGray4: {
    main: '#90939F',
    light: '#90939F',
    dark: '#90939F',
  },
  neutralGray6: {
    main: '#6A6E79',
    light: '#6A6E79',
    dark: '#6A6E79',
  },
  neutralGray8: {
    main: '#464B52',
    light: '#464B52',
    dark: '#464B52',
  },
  neutralGray9: {
    main: '#353A40',
    light: '#353A40',
    dark: '#353A40',
  },
  neutralGray10: {
    main: '#171C1E',
    light: '#171C1E',
    dark: '#171C1E',
  },
  blue: {
    main: '#0E416C',
    light: '#0E416C',
    dark: '#004F83',
  },
  white: {
    main: '#FFF',
    light: '#FFF',
    dark: '#FFF',
  },
  breadcrumbs: {
    main: '#FFF',
    light: '#FFF',
    dark: '#FFF',
  },
} as PaletteOptions;

declare module '@mui/material/styles' {
  interface Palette {
    neutralGray: Palette['primary'];
    neutralGray0: Palette['primary'];
    neutralGray1: Palette['primary'];
    neutralGray2: Palette['primary'];
    neutralGray3: Palette['primary'];
    neutralGray4: Palette['primary'];
    neutralGray6: Palette['primary'];
    neutralGray10?: Palette['primary'];
    blue: Palette['primary'];
    white: Palette['primary'];
    breadcrumbs: Palette['primary'];
  }

  interface PaletteOptions {
    neutralGray?: PaletteOptions['primary'];
    neutralGray0?: PaletteOptions['primary'];
    neutralGray1?: PaletteOptions['primary'];
    neutralGray2?: PaletteOptions['primary'];
    neutralGray3?: PaletteOptions['primary'];
    neutralGray4?: PaletteOptions['primary'];
    neutralGray6?: PaletteOptions['primary'];
    neutralGray10?: PaletteOptions['primary'];
    blue?: PaletteOptions['primary'];
    white?: PaletteOptions['primary'];
    breadcrumbs?: PaletteOptions['primary'];
  }
}
